"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ProfileGate_1 = __importDefault(require("./ProfileGate"));
exports.default = ProfileGate_1.default;
